function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { DateTime } from 'luxon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { uuid } from 'uuidv4';
import Toggle from 'react-toggle';
import { Input, TextArea } from '../../../../Input';
import PhotosPanel from '../../PhotosPanel';
import './MotoDetailsPanel.css';

var MotoDetailsPanel = /*#__PURE__*/function (_React$Component) {
  _inherits(MotoDetailsPanel, _React$Component);

  function MotoDetailsPanel(props) {
    var _this;

    _classCallCheck(this, MotoDetailsPanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MotoDetailsPanel).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onChangeMotoNumber", function (event) {
      var _this$props = _this.props,
          updateLogBookEntry = _this$props.updateLogBookEntry,
          moto = _this$props.moto;
      moto.number = event.target.value;
      updateLogBookEntry();
      return moto.number;
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeMotoFinish", function (event) {
      var _this$props2 = _this.props,
          updateLogBookEntry = _this$props2.updateLogBookEntry,
          moto = _this$props2.moto;
      var number = event.target.value;
      moto.finish = number.substring(number.length - 1, number.length);

      if (moto.finish === '9') {
        moto.finish = '';
      }

      updateLogBookEntry();
      return moto.finish;
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeLaneNumber", function (event) {
      var _this$props3 = _this.props,
          updateLogBookEntry = _this$props3.updateLogBookEntry,
          moto = _this$props3.moto;
      var number = event.target.value;
      moto.laneNumber = number.substring(number.length - 1, number.length);

      if (moto.laneNumber === '9') {
        moto.laneNumber = '';
      }

      updateLogBookEntry();
      return moto.laneNumber;
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeRidersInMoto", function (event) {
      var _this$props4 = _this.props,
          updateLogBookEntry = _this$props4.updateLogBookEntry,
          moto = _this$props4.moto;
      var number = event.target.value;
      moto.ridersInMoto = number.substring(number.length - 1, number.length);

      if (moto.ridersInMoto === '9') {
        moto.ridersInMoto = '';
      }

      updateLogBookEntry();
      return moto.ridersInMoto;
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeTransferSpotsAvailable", function (event) {
      var _this$props5 = _this.props,
          updateLogBookEntry = _this$props5.updateLogBookEntry,
          moto = _this$props5.moto;
      var number = event.target.value;
      moto.transferSpotsAvailable = number.substring(number.length - 1, number.length);

      if (moto.transferSpotsAvailable === '9') {
        moto.transferSpotsAvailable = '';
      }

      updateLogBookEntry();
      return moto.transferSpotsAvailable;
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeNotes", function (event) {
      var _this$props6 = _this.props,
          updateLogBookEntry = _this$props6.updateLogBookEntry,
          moto = _this$props6.moto;
      moto.notes = event.target.value;
      updateLogBookEntry();
      return moto.notes;
    });

    _this.state = {
      selectedMoto: undefined
    };
    return _this;
  }

  _createClass(MotoDetailsPanel, [{
    key: "render",
    value: function render() {
      var onChangeMotoNumber = this.onChangeMotoNumber,
          onChangeMotoFinish = this.onChangeMotoFinish,
          onChangeLaneNumber = this.onChangeLaneNumber,
          onChangeRidersInMoto = this.onChangeRidersInMoto,
          onChangeTransferSpotsAvailable = this.onChangeTransferSpotsAvailable,
          onChangeNotes = this.onChangeNotes;
      var _this$props7 = this.props,
          updateLogBookEntry = _this$props7.updateLogBookEntry,
          logBookEntry = _this$props7.logBookEntry,
          entry = _this$props7.entry,
          moto = _this$props7.moto,
          selectMoto = _this$props7.selectMoto,
          mapMotoName = _this$props7.mapMotoName,
          width = _this$props7.width,
          storage = _this$props7.storage;
      return React.createElement(React.Fragment, null, React.createElement("div", {
        className: "motos selected-moto"
      }, React.createElement("div", {
        className: "rounds"
      }, React.createElement("div", {
        className: "round"
      }, React.createElement("div", {
        className: "title",
        dangerouslySetInnerHTML: {
          __html: mapMotoName(moto && moto.name)
        },
        onClick: function onClick(e) {
          return selectMoto(moto);
        }
      })))), moto && React.createElement("div", {
        className: "moto-details"
      }, React.createElement(Input, {
        label: "Moto Number",
        locked: false,
        active: false,
        type: "number",
        onChange: onChangeMotoNumber,
        value: moto.number
      }), React.createElement(Input, {
        label: "Lane Number",
        locked: false,
        active: false,
        type: "number",
        onChange: onChangeLaneNumber,
        value: moto.laneNumber
      }), React.createElement(Input, {
        label: "Finish Position",
        locked: false,
        active: false,
        type: "number",
        onChange: onChangeMotoFinish,
        value: moto.finish
      }), React.createElement(Input, {
        label: "Riders in Moto",
        locked: false,
        active: false,
        type: "number",
        onChange: onChangeRidersInMoto,
        value: moto.ridersInMoto
      }), React.createElement(Input, {
        label: "Transfer Spots Available",
        locked: false,
        active: false,
        type: "number",
        onChange: onChangeTransferSpotsAvailable,
        value: moto.transferSpotsAvailable
      }), React.createElement(TextArea, {
        label: "Moto Notes",
        locked: false,
        active: false,
        type: "text",
        onChange: onChangeNotes,
        value: moto.notes
      }), React.createElement(PhotosPanel, {
        width: width,
        parent: moto,
        updateLogBookEntry: updateLogBookEntry,
        storage: storage
      })));
    }
  }]);

  return MotoDetailsPanel;
}(React.Component);

export default MotoDetailsPanel;